import { render, staticRenderFns } from "./InvoiceSingle.vue?vue&type=template&id=2d73e841&scoped=true&lang=pug"
import script from "./InvoiceSingle.vue?vue&type=script&lang=js"
export * from "./InvoiceSingle.vue?vue&type=script&lang=js"
import style0 from "./InvoiceSingle.vue?vue&type=style&index=0&id=2d73e841&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d73e841",
  null
  
)

export default component.exports